// extracted by mini-css-extract-plugin
export default {"root":"IQiN1c","alignmentWrapper":"eUfJ8X"};